export default __webpack_public_path__ + "static/media/left.5321b854.png";